// Client V2 common imports
const { createFeedReducer } = require('client-v2/common/containers/feed/reducer')

module.exports = createFeedReducer(require('./actions'))
